/**
 * Function to remove hash symbol from path
 * @function
 * @return {string | undefined} - Path without hash
 */
export const removeHashFromPath = () => {
  if (window.history.pushState) {
    return window.history.pushState('', '/', window.location.pathname);
  } else {
    return (window.location.hash = '');
  }
};
